import bulkOrders from "./bulkOrders/actions";

export default {
  ...bulkOrders,
};
